import { Grid } from "@mui/material";
import classes from "./ListContainer.module.css";

const ListContainer = ({ children, forceLtr }) => {
  return (
    <Grid
      container
      item
      xs={11.8}
      sm={11.2}
      md={11}
      className={[classes.container, forceLtr ? classes.forceLtr : null].join(" ")}
    >
      {children}
    </Grid>
  );
};

export default ListContainer;
